import { Link } from "react-router-dom";
import { useState } from "react";
import verifid from '../../assets/verificado.png';

const ProductCard = ({ product, viewMode }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <Link to={`/product/${product.id}`}>
        <div
          key={product.id}
          className="
            animate-fadeIn
            relative 
            border border-gray-200 
            rounded-lg 
            overflow-hidden 
            transition-transform 
            transform
            hover:scale-105 
            hover:-translate-y-1 
            hover:shadow-lg 
            hover:border-green-300 
            hover:bg-green-50
            cursor-pointer
            max-w-sm w-full mx-auto
          "
        >
          {/* Botón de verificado (se muestra solo si viewMode !== 4) */}
          {viewMode !== 4 && (
            <button
              type="button"
              onClick={(e) => toggleModal(e)}
              className="absolute right-1 text-blue-500"
            >
              <img src={verifid} alt="Verificado" className="w-20 h-20" />
            </button>
          )}

          {/* Imagen del producto */}
          <div className="w-full bg-gray-100 rounded-t-lg overflow-hidden">
            <img
              src={`${process.env.REACT_APP_API_URL}${product.get_thumbnail}`}
              alt={product.name}
              className="w-full object-cover aspect-[4/5]"
            />
          </div>

          {/* Detalles para vista móvil */}
          {viewMode !== 4 && (
            <div className="p-4 rounded-b-lg block sm:hidden">
              {viewMode === 1 && (
                <>
                  <p className="text-gray-600 text-sm">
                    {product.brand || " "}
                  </p>
                  <h3 className="text-md font-semibold text-gray-900">
                    {product.name || " "}
                  </h3>
                  <div className="flex items-center justify-between mt-2">
                    {product.type === "clothing" && (
                      <span className="bg-white px-2 py-1 text-sm font-medium rounded-full border">
                        {product.size === "small"
                          ? "S"
                          : product.size === "medium"
                          ? "M"
                          : product.size === "large"
                          ? "L"
                          : product.size === "extra_large"
                          ? "XL"
                          : product.size}
                      </span>
                    )}
                    <p className="text-lg font-bold text-gray-900">
                      ${product.price || " "}
                    </p>
                    <span className="text-gray-600 text-sm">
                      {product.category?.name || " "}
                    </span>
                  </div>
                </>
              )}
              {viewMode === 2 && (
                <>
                  <h3 className="text-md font-semibold text-gray-900">
                    {product.name || " "}
                  </h3>
                  <p className="text-lg font-bold text-gray-900">
                    ${product.price || " "}
                  </p>
                </>
              )}
            </div>
          )}

          {/* Detalles para vista desktop */}
          <div className="p-4 rounded-b-lg hidden sm:block">
            <p className="text-gray-600 text-sm">{product.brand || " "}</p>
            <h3 className="text-md font-semibold text-gray-900">
              {product.name || " "}
            </h3>
            <div className="flex items-center justify-between mt-2">
              {product.type === "clothing" && (
                <span className="bg-white px-2 py-1 text-sm font-medium rounded-full border">
                  {product.size === "small"
                    ? "S"
                    : product.size === "medium"
                    ? "M"
                    : product.size === "large"
                    ? "L"
                    : product.size === "extra_large"
                    ? "XL"
                    : product.size}
                </span>
              )}
              <p className="text-lg font-bold text-gray-900">
              {product.price
    ? `$${new Intl.NumberFormat('en-US').format(Math.floor(product.price))}`
    : " "}
              </p>
              <span className="text-gray-600 text-sm">
                {product.category?.name || " "}
              </span>
            </div>
          </div>
        </div>
      </Link>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
          onClick={toggleModal}
        >
          <div
            className="bg-white p-6 rounded-lg shadow-lg max-w-md mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-xl font-semibold mb-2">Product Verified</h2>
            <p className="text-gray-700 mb-4">
              This product has been verified using advanced methods:
            </p>
            <ul className="list-disc pl-5 text-gray-700 text-sm space-y-1">
              <li>
                <strong>AI Image Analysis:</strong> Compares the piece with historical databases, detecting aging patterns, textures, and materials.
              </li>
              <li>
                <strong>Material Recognition:</strong> Uses spectroscopy and computer vision to verify if the materials match the declared era.
              </li>
              <li>
                <strong>Aging Pattern Analysis:</strong> Detects microcracks, patinas, and natural or artificial oxidation.
              </li>
              <li>
                <strong>Blockchain & Digital Certification:</strong> Registers verified pieces on blockchain to prevent fraud and track provenance.
              </li>
              <li>
                <strong>AI Predictive Models:</strong> Algorithms detect the probability of forgery based on historical data.
              </li>
              <li>
                <strong>Museum Database Comparison:</strong> Accesses archives from the Louvre, MET, and other museums to verify similarities.
              </li>
            </ul>
            <button
              onClick={toggleModal}
              className="mt-4 px-4 py-2 bg-green-500 text-white rounded-lg"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductCard;
